import store from "@/state/store";

export default [
  {
    path: "/account/profile",
    name: "account-profile",
    component: () => import("../views/account/profile.vue"),
    meta: {
      title: "Account Profile",
      authRequired: false,
    },
  },

  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      authRequired: false,
      beforeResolve: (routeTo, routeFrom, next) => {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      authRequired: false,
      beforeResolve: (routeTo, routeFrom, next) => {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },

  {
    path: "/reset-password",
    name: "Reset password",
    component: () => import("../views/account/reset-password.vue"),
    meta: {
      title: "Reset Password",
      authRequired: false,
      beforeResolve: (routeTo, routeFrom, next) => {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },

  {
    path: "/verification-code",
    name: "Verification code",
    component: () => import("../views/account/verification-code.vue"),
    meta: {
      title: "Verification Code",
      authRequired: false,
      beforeResolve: (routeTo, routeFrom, next) => {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },

  {
    path: "/verification-otp",
    name: "Verification otp",
    component: () => import("../views/account/verification-otp.vue"),
    meta: {
      title: "Verification Otp",
      authRequired: false,
      beforeResolve: (routeTo, routeFrom, next) => {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },

  {
    path: "/",
    name: "default",
    component: () => import("../views/dashboard/ecommerce/index.vue"),
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
  },

  {
    path: "/bags",
    name: "bags",
    component: () => import("../views/bags/index.vue"),
    meta: {
      title: "Bags",
      authRequired: true,
    },
  },

  {
    path: "/brand",
    name: "brand",
    component: () => import("../views/brand/index.vue"),
    meta: {
      title: "Brand",
      authRequired: true,
    },
  },

  {
    path: "/cards",
    name: "cards",
    component: () => import("../views/cards/index.vue"),
    meta: {
      title: "Cards",
      authRequired: true,
    },
  },

  {
    path: "/category",
    name: "category",
    component: () => import("../views/category/index.vue"),
    meta: {
      title: "Category",
      authRequired: true,
    },
  },

  {
    path: "/cover",
    name: "cover",
    component: () => import("../views/cover/index.vue"),
    meta: {
      title: "Cover",
      authRequired: true,
    },
  },

  {
    path: "/dashboard/ecommerce/revenue",
    name: "dashboard-ecommerce-revenue",
    component: () => import("../views/dashboard/ecommerce/revenue.vue"),
    meta: {
      title: "Dashboard Ecommerce Revenue",
      authRequired: true,
    },
  },

  {
    path: "/dashboard/ecommerce/sales-location",
    name: "dashboard-ecommerce-sales-location",
    component: () => import("../views/dashboard/ecommerce/sales-location.vue"),
    meta: {
      title: "Dashboard Ecommerce Sales Location",
      authRequired: true,
    },
  },

  {
    path: "/dashboard/ecommerce/selling-product",
    name: "dashboard-ecommerce-selling-product",
    component: () => import("../views/dashboard/ecommerce/selling-product.vue"),
    meta: {
      title: "Dashboard Ecommerce Selling Product",
      authRequired: true,
    },
  },

  {
    path: "/fill",
    name: "fill",
    component: () => import("../views/fill/index.vue"),
    meta: {
      title: "Fill",
      authRequired: true,
    },
  },

  {
    path: "/forecasting",
    name: "forecasting",
    component: () => import("../views/forecasting/index.vue"),
    meta: {
      title: "Forecasting",
      authRequired: true,
    },
  },

  {
    path: "/fulfillment-costs",
    name: "fulfillment-costs",
    component: () => import("../views/fulfillment-costs/index.vue"),
    meta: {
      title: "Fulfillment Costs",
      authRequired: true,
    },
  },

  {
    path: "/inventory",
    name: "inventory",
    component: () => import("../views/inventory/index.vue"),
    meta: {
      title: "Inventory",
      authRequired: true,
    },
  },

  {
    path: "/inventory-log",
    name: "inventory-log",
    component: () => import("../views/inventory-log/index.vue"),
    meta: {
      title: "Inventory Log",
      authRequired: true,
    },
  },

  {
    path: "/landed-cost",
    name: "landed-cost",
    component: () => import("../views/landed-cost/index.vue"),
    meta: {
      title: "Landed Cost",
      authRequired: true,
    },
  },

  {
    path: "/listings",
    name: "listings",
    component: () => import("../views/listings/index.vue"),
    meta: {
      title: "Listings",
      authRequired: true,
    },
  },

  {
    path: "/parts",
    name: "parts",
    component: () => import("../views/parts/index.vue"),
    meta: {
      title: "Parts",
      authRequired: true,
    },
  },

  {
    path: "/parts/detail",
    name: "detail",
    component: () => import("../views/parts/detail/index.vue"),
    meta: {
      title: "Detail",
      authRequired: true,
    },
  },

  {
    path: "/platforms",
    name: "platforms",
    component: () => import("../views/platforms/index.vue"),
    meta: {
      title: "Platforms",
      authRequired: true,
    },
  },

  {
    path: "/product",
    name: "product",
    component: () => import("../views/product/index.vue"),
    meta: {
      title: "Product",
      authRequired: true,
    },
  },

  {
    path: "/product/add-product",
    name: "add-product",
    component: () => import("../views/product/add-product/index.vue"),
    meta: {
      title: "Add Product",
      authRequired: true,
    },
  },

  {
    path: "/product/breakdown",
    name: "breakdown",
    component: () => import("../views/product/breakdown/index.vue"),
    meta: {
      title: "Breakdown",
      authRequired: true,
    },
  },

  {
    path: "/product/custom-field",
    name: "custom-field",
    component: () => import("../views/product/custom-field/index.vue"),
    meta: {
      title: "Custom Field",
      authRequired: true,
    },
  },

  {
    path: "/product/detail",
    name: "product-detail",
    component: () => import("../views/product/detail/index.vue"),
    meta: {
      title: "Product Details",
      authRequired: true,
    },
  },

  {
    path: "/product/edit-product",
    name: "edit-product",
    component: () => import("../views/product/edit-product/index.vue"),
    meta: {
      title: "Edit Product",
      authRequired: true,
    },
  },

  {
    path: "/product/finish-good",
    name: "finish-good",
    component: () => import("../views/product/finish-good/index.vue"),
    meta: {
      title: "Finish Good",
      authRequired: true,
    },
  },

  {
    path: "/product/part",
    name: "part",
    component: () => import("../views/product/part/index.vue"),
    meta: {
      title: "Part",
      authRequired: true,
    },
  },

  {
    path: "/production",
    name: "production",
    component: () => import("../views/production/index.vue"),
    meta: {
      title: "Production",
      authRequired: true,
    },
  },

  {
    path: "/production/add-production",
    name: "add-production",
    component: () => import("../views/production/add-production/index.vue"),
    meta: {
      title: "Add Production",
      authRequired: true,
    },
  },

  {
    path: "/production/production-view",
    name: "production-view",
    component: () => import("../views/production/production-view/index.vue"),
    meta: {
      title: "Production View",
      authRequired: true,
    },
  },

  {
    path: "/production/schedule",
    name: "schedule",
    component: () => import("../views/production/schedule/index.vue"),
    meta: {
      title: "Schedule",
      authRequired: true,
    },
  },

  {
    path: "/purchase/add-purchase",
    name: "add-purchase",
    component: () => import("../views/purchase/add-purchase/index.vue"),
    meta: {
      title: "Add Purchase",
      authRequired: true,
    },
  },

  {
    path: "/purchase/import-pdf-modal",
    name: "purchase-import-pdf-modal",
    component: () => import("../views/purchase/import-pdf-modal.vue"),
    meta: {
      title: "Purchase Import Pdf Modal",
      authRequired: true,
    },
  },

  {
    path: "/purchase/purchase-view",
    name: "purchase-view",
    component: () => import("../views/purchase/purchase-view/index.vue"),
    meta: {
      title: "Purchase View",
      authRequired: true,
    },
  },

  {
    path: "/purchases",
    name: "purchases",
    component: () => import("../views/purchase/index.vue"),
    meta: {
      title: "Purchases",
      authRequired: true,
    },
  },

  {
    path: "/reports",
    name: "reports",
    component: () => import("../views/reports/index.vue"),
    meta: {
      title: "Reports",
      authRequired: true,
    },
  },

  {
    path: "/returns",
    name: "returns",
    component: () => import("../views/returns/index.vue"),
    meta: {
      title: "Returns",
      authRequired: true,
    },
  },

  {
    path: "/returns/claims",
    name: "returns-claims",
    component: () => import("../views/returns/claims.vue"),
    meta: {
      title: "Returns Claims",
      authRequired: true,
    },
  },

  {
    path: "/returns/process",
    name: "returns-process",
    component: () => import("../views/returns/process.vue"),
    meta: {
      title: "Returns Process",
      authRequired: true,
    },
  },

  {
    path: "/returns/processing-log",
    name: "returns-processing-log",
    component: () => import("../views/returns/processing-log.vue"),
    meta: {
      title: "Returns Processing Log",
      authRequired: true,
    },
  },

  {
    path: "/returns/settings",
    name: "returns-settings",
    component: () => import("../views/returns/settings.vue"),
    meta: {
      title: "Returns Settings",
      authRequired: true,
    },
  },

  {
    path: "/role",
    name: "role",
    component: () => import("../views/role/index.vue"),
    meta: {
      title: "Role",
      authRequired: true,
    },
  },

  {
    path: "/sales",
    name: "sales",
    component: () => import("../views/sales/index.vue"),
    meta: {
      title: "Sales",
      authRequired: true,
    },
  },

  {
    path: "/sales/add-sale",
    name: "add-sale",
    component: () => import("../views/sales/add-sale/index.vue"),
    meta: {
      title: "Add Sale",
      authRequired: true,
    },
  },

  {
    path: "/sales/order-detail",
    name: "order-detail",
    component: () => import("../views/sales/order-detail/index.vue"),
    meta: {
      title: "Order Detail",
      authRequired: true,
    },
  },

  {
    path: "/sales/sale-view",
    name: "sale-view",
    component: () => import("../views/sales/sale-view/index.vue"),
    meta: {
      title: "Sale View",
      authRequired: true,
    },
  },

  {
    path: "/sales/trash",
    name: "trash",
    component: () => import("../views/sales/trash/index.vue"),
    meta: {
      title: "Trash",
      authRequired: true,
    },
  },

  {
    path: "/settings/general",
    name: "general",
    component: () => import("../views/settings/general/index.vue"),
    meta: {
      title: "General",
      authRequired: true,
    },
  },

  {
    path: "/shipping",
    name: "shipping",
    component: () => import("../views/shipping/index.vue"),
    meta: {
      title: "Shipping",
      authRequired: true,
    },
  },

  {
    path: "/supplier",
    name: "supplier",
    component: () => import("../views/supplier/index.vue"),
    meta: {
      title: "Supplier",
      authRequired: true,
    },
  },

  {
    path: "/user",
    name: "user",
    component: () => import("../views/user/index.vue"),
    meta: {
      title: "User",
      authRequired: true,
    },
  },

  {
    path: "/user/view",
    name: "user-view",
    component: () => import("../views/user/view.vue"),
    meta: {
      title: "User View",
      authRequired: true,
    },
  }
];
